export const ErrorCode = Object.freeze({
    SPEECH_TOKEN_ERROR: "SPEECH_TOKEN_ERROR",
    TRANSCRIPTION_ERROR: "TRANSCRIPTION_ERROR",
    TRANSLATION_ERROR: "TRANSLATION_ERROR",
    FEEDBACK_ERROR: "FEEDBACK_ERROR",
    MICROPHONE_BLOCKED_ERROR: "MICROPHONE_BLOCKED_ERROR",
    SESSION_ERROR: "SESSION_ERROR",
    REPORT_ERROR: "REPORT_ERROR"
});

export function getUserErrorMessage(errorCode) {
    switch (errorCode) {
        case ErrorCode.SPEECH_TOKEN_ERROR:
            return "We're having trouble connecting to our voice service right now. Please check your internet and try again.";

        case ErrorCode.TRANSCRIPTION_ERROR:
            return "We couldn't complete the transcription right now.";

        case ErrorCode.TRANSLATION_ERROR:
            return "We're having trouble translating this right now. Please try again!";
        case ErrorCode.FEEDBACK_ERROR:
            return "We're having trouble in submitting your feedback right now. Please try again!";

        case ErrorCode.MICROPHONE_BLOCKED_ERROR:
            return "Microphone access is blocked. Please enable microphone access in your browser settings to continue.";

        case ErrorCode.SESSION_ERROR:
            return "";

         case ErrorCode.REPORT_ERROR:
            return "We're having trouble getting your reports right now. Please try again!";

        default:
            return "Something went wrong. Please try again.";
    }
}
